import React, { useEffect, useState } from 'react'
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";
import { Grid } from '@mui/material';
import SoftBox from 'components/SoftBox';
import { baseURL } from 'utils/api';
import SoftButton from 'components/SoftButton';
import AddressForm from "../businessDetail/components/Address/form/index";
import NotFound from 'components/notFound';
import Loading from 'components/ApnaLoading';
import { createSvgIcon } from '@mui/material/utils';

const index = () => {

  const [data, setData] = useState([]);
  const id = localStorage.getItem("id");
  const [show, setShow] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [loading, setLoading] = useState(false);
  const PlusIcon = createSvgIcon(
    // credit: plus icon from https://heroicons.com
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
    </svg>,
    'Plus',
  );


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        fetch(`${baseURL}getAllBusinessForMerchant/${id}`)
          .then((res) => res.json())
          .then((res) => {
            if (res.success) {
              // const findDefault = res?.profile.find((item) => item.isDefault === true);
              // localStorage.setItem("defaultProfile", findDefault?.profileImage||null);
              setLoading(false)
              setData(res?.data);
            }
          });
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [refresh]);


  const handelRefresh     = () => { 
    setRefresh(refresh + 1);
  } 




  const findMainBusiness = data.find((item) => item.isDefault == true);




  return (
    <DashboardLayout>
      <DashboardNavbar />
      
      <AddressForm setRefresh={setRefresh} mainBusiness={findMainBusiness} show={show} unShow={setShow} />
      <SoftBox p={2} pt={3}>
        <Grid container spacing={3}>
          {loading ? <Loading/> :  
            data && data?.length > 0 ? (
              <>
                {data.map((item) => (
                  <Grid item xs={12} md={6} xl={3}>
                    <DefaultProjectCard
                      image={item?.businessLogo}
                      label={item?.address?.addLine?.length>28?item?.address?.addLine.slice(0,28)+'...':item?.address?.addLine}
                      title={item?.locationName}
                      subTitle={item?.businessName}
                      setRefresh={handelRefresh}
                      businessId={item?._id}  
                      primary={item?.isDefault}
                      action={{
                        type: "internal",
                        route: `/business/detail/${item?._id}`,
                        color: "info",
                        label: "view ",
                      }}
                    />
                  </Grid>
                ))}
                <Grid item xs={12} md={6} xl={3}>
                  <SoftBox
                    onClick={() => setShow(!show)}
                    sx={{
                      height: '100%',
                      minHeight: 340,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: '1px solid transparent',
                      borderRadius: '12px',
                      cursor: 'pointer',
                      background: '#fff',
                      transition: 'box-shadow 0.2s',
                      boxShadow: '0 2px 16px 0 rgba(140,152,164,.08)',
                      backgroundImage: 'linear-gradient(#fff, #fff), linear-gradient(135deg, rgb(199, 2, 178), rgb(32, 132, 218))',
                      backgroundOrigin: 'border-box',
                      backgroundClip: 'padding-box, border-box',
                      '&:hover': {
                        boxShadow: '0 4px 24px 0 rgba(140,152,164,.16)',
                      },
                    }}
                  >
                    <span style={{ fontSize: 38, marginBottom: 4 }}><PlusIcon color="secondary" /></span>
                    <span style={{ 
                      fontSize: 18, 
                      fontWeight: 500,
                      background: 'linear-gradient(135deg, rgb(199, 2, 178), rgb(32, 132, 218))',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    }}>Add more address</span>
                  </SoftBox>
                </Grid>
              </>
            ) : <NotFound />
          }
        </Grid>
      </SoftBox>
    </DashboardLayout>
  )
}

export default index








